var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9704 17.5861C32.9304 16.6262 32.9304 15.0696 31.9704 14.1096L19.9438 2.09462C18.0233 0.176132 14.9116 0.176893 12.9921 2.09631L0.970021 14.1184C0.0099929 15.0784 0.0099929 16.635 0.970021 17.595C1.93007 18.5552 3.48659 18.5552 4.44665 17.595L14.7363 7.3054C15.6965 6.34542 17.2529 6.34542 18.2128 7.3054L28.4938 17.5861C29.4538 18.5461 31.0104 18.5461 31.9704 17.5861Z",
    fill: "rgba(239, 239, 239, 0.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDownArrow);
export default __webpack_public_path__ + "static/media/card-down-arrow.76a9f05e28989af764c526b388965b48.svg";
export { ForwardRef as ReactComponent };